import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {HomeComponent} from '@view/web/home/home.component';
import {SharedModule} from '@shared/shared.module';
import {AppFormModule} from '@view/form/appForm.module';
import {ViewModule} from '@view/view.module';
import {NewsComponent} from '@view/widget/news/news.component';

@NgModule({
  declarations: [
    NewsComponent,
    HomeComponent
  ],
  imports: [
    SharedModule,
    AppFormModule,
    ViewModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeModule {
}
